/* Trending Collections — scroll-snap slider with integer slidesPerView,
   group-based dots (one dot per group of --spv cards), edge-riding arrows
   that step one card per click. Vanilla JS, multi-instance, Shopify
   theme-editor aware. No dependencies, no autoplay. */
(function () {
  'use strict';

  function Trending(root) {
    if (!root || root.__ntTrendInit) return;
    root.__ntTrendInit = true;

    var track = root.querySelector('.nt-trending__track');
    if (!track) return;
    var prev = root.querySelector('.nt-trending__arrow--prev');
    var next = root.querySelector('.nt-trending__arrow--next');
    var dotsWrap = root.querySelector('.nt-trending__dots');
    var dots = [];

    function cards() { return track.querySelectorAll('.nt-trending__card'); }
    function maxScroll() { return track.scrollWidth - track.clientWidth; }

    /* Distance from one card to the next (card width + gap). */
    function pitch() {
      var cs = cards();
      if (cs.length > 1) {
        var p = cs[1].offsetLeft - cs[0].offsetLeft;
        if (p > 1) return p;
      }
      return cs.length ? cs[0].offsetWidth + 20 : 300;
    }

    /* Integer cards-per-view, set by the CSS breakpoint ladder (--spv). */
    function spv() {
      var v = parseFloat(getComputedStyle(track).getPropertyValue('--spv'));
      return v > 0 ? Math.round(v) : 1;
    }

    /* One dot per GROUP of spv cards: 11 cards / 4 per view -> 3 dots
       (cards 1-4, 5-8, 9-11). */
    function pageCount() {
      var total = cards().length;
      return Math.max(1, Math.ceil(total / spv()));
    }

    function currentPage() {
      var max = maxScroll();
      if (max <= 1) return 0;
      if (track.scrollLeft >= max - 2) return pageCount() - 1;
      var leftmost = Math.round(track.scrollLeft / pitch());
      return Math.min(pageCount() - 1, Math.round(leftmost / spv()));
    }

    function updateArrows() {
      var max = maxScroll();
      var scrollable = max > 1;
      var x = track.scrollLeft;
      if (prev) prev.disabled = !scrollable || x <= 2;
      if (next) next.disabled = !scrollable || x >= max - 2;
    }

    function syncDots() {
      var i = currentPage();
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
    }

    function buildDots() {
      if (!dotsWrap) return;
      var n = pageCount();
      var scrollable = maxScroll() > 1;
      dotsWrap.innerHTML = '';
      dots = [];
      dotsWrap.style.display = (!scrollable || n < 2) ? 'none' : '';
      if (!scrollable || n < 2) return;
      for (var p = 0; p < n; p++) {
        (function (group) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'nt-trending__dot';
          b.setAttribute('aria-label', 'Go to card group ' + (group + 1));
          b.addEventListener('click', function () {
            track.scrollTo({ left: Math.min(group * spv() * pitch(), maxScroll()), behavior: 'smooth' });
          });
          dotsWrap.appendChild(b);
          dots.push(b);
        })(p);
      }
      syncDots();
    }

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; updateArrows(); syncDots(); });
    }, { passive: true });

    /* Arrows advance exactly ONE card per click. */
    function step(dir) {
      track.scrollBy({ left: dir * pitch(), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { if (!prev.disabled) step(-1); });
    if (next) next.addEventListener('click', function () { if (!next.disabled) step(1); });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        if (!root.isConnected) return;
        buildDots();
        updateArrows();
      }, 150);
    });

    updateArrows();
    buildDots();
  }

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    var roots = container.querySelectorAll('.nt-trending');
    Array.prototype.forEach.call(roots, Trending);
    if (container.classList && container.classList.contains('nt-trending')) Trending(container);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    if (!e.target || !e.target.closest) return;
    var card = e.target.closest('.nt-trending__card');
    if (card) card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  });
})();
